export class LatestNews {
  id?: number;
  latestNewsContent?: string;

  constructor(id: number, latestNewsContent: string) {
    this.id = id;
    this.latestNewsContent = latestNewsContent;
  }
}
